import { ActionType } from "./ActionType";
import { StoreState } from "./interfaces/storeState";

const reducers = (
  state: StoreState = { products: {} },
  action: { data; type: ActionType }
) => {
  switch (action.type) {
    case ActionType.SAVE_MARKET:
      return { ...state, market: action.data };

    case ActionType.SAVE_FLAG_MARKET:
      return { ...state, flagMarket: action.data };

    case ActionType.SAVE_WIZARD:
      return { ...state, wizard: action.data };

    case ActionType.PRODUCTS_SAVE_DATA:
      return {
        ...state,
        products: {
          ...state.products,
          [action.data.type]: {
            showAll: false,
            data: action.data.result,
          },
        },
      };

    case ActionType.SAVE_WIZARD_ENABLE_NEXT:
      return { ...state, wizard: { ...state.wizard, enableNext: action.data } };

    case ActionType.SAVE_MACHINE_TONNAGE:
      return { ...state, machineTonnage: action.data };

    case ActionType.SAVE_PRODUCT_CATEGORY:
      return {
        ...state,
        product: { ...state.product, productCategory: action.data },
      };

    case ActionType.SAVE_PRODUCT_MACHINE_FIXING_TYPE:
      return {
        ...state,
        product: { ...state.product, machineFixingType: action.data },
      };

    case ActionType.SAVE_PRODUCT_TOOLS_PRODUCT_TYPES:
      return {
        ...state,
        product: { ...state.product, toolsProductTypes: action.data },
      };

    case ActionType.SAVE_OPTIONAL_TOOLS_PRODUCT_TYPES:
      return {
        ...state,
        optional: { ...state.optional, toolsProductTypes: action.data },
      };

    case ActionType.SAVE_OPTIONAL_TOOLS_IS_TOOLS_SELECTED:
      return {
        ...state,
        optional: { ...state.optional, isToolsSelected: action.data },
      };

    case ActionType.SAVE_OPTIONAL_TOOLS_IS_TILTROTATORS_SELECTED:
      return {
        ...state,
        optional: { ...state.optional, isTiltrotatorsSelected: action.data },
      };

    case ActionType.SAVE_OPTIONAL_TOOLS_IS_MACHINE_FIXINGS_SELECTED:
      return {
        ...state,
        optional: { ...state.optional, isMachineFixingsSelected: action.data },
      };

    case ActionType.SAVE_OPTIONAL_MACHINE_FIXING_TYPE:
      return {
        ...state,
        optional: { ...state.optional, machineFixingType: action.data },
      };

    case ActionType.SAVE_CART_SELECTIONS_PRODUCT_TILTROTATOR:
      return {
        ...state,
        cartSelections: {
          ...state.cartSelections,
          product: {
            ...(state.cartSelections?.product
              ? state.cartSelections.product
              : {}),
            tiltrotator: action.data,
          },
        },
      };

    case ActionType.SAVE_CART_SELECTIONS_PRODUCT_MACHINE_FIXING:
      return {
        ...state,
        cartSelections: {
          ...state.cartSelections,
          product: {
            ...(state.cartSelections?.product
              ? state.cartSelections.product
              : {}),
            machineFixing: action.data,
          },
        },
      };

    case ActionType.SAVE_CART_SELECTIONS_PRODUCT_UPPER_BRACKET:
      return {
        ...state,
        cartSelections: {
          ...state.cartSelections,
          product: {
            ...(state.cartSelections?.product
              ? state.cartSelections.product
              : {}),
            upperBracket: action.data,
          },
        },
      };

    case ActionType.SAVE_CART_SELECTIONS_PRODUCT_LOWER_BRACKET:
      return {
        ...state,
        cartSelections: {
          ...state.cartSelections,
          product: {
            ...(state.cartSelections?.product
              ? state.cartSelections.product
              : {}),
            lowerBracket: action.data,
          },
        },
      };

    case ActionType.SAVE_CART_SELECTIONS_PRODUCT_GRAPPLE_MODULE:
      return {
        ...state,
        cartSelections: {
          ...state.cartSelections,
          product: {
            ...(state.cartSelections?.product
              ? state.cartSelections.product
              : {}),
            grappleModule: action.data,
          },
        },
      };

    case ActionType.SAVE_CART_SELECTIONS_PRODUCT_NO_GRAPPLE_MODULE_SELECTED:
      return {
        ...state,
        cartSelections: {
          ...state.cartSelections,
          product: {
            ...(state.cartSelections?.product
              ? state.cartSelections.product
              : {}),
            isNoneGrappleModuleSelected: action.data,
          },
        },
      };

    case ActionType.SAVE_CART_SELECTIONS_PRODUCT_TOOLS_PRODUCT_ITEMS:
      return {
        ...state,
        cartSelections: {
          ...state.cartSelections,
          product: {
            ...(state.cartSelections?.product
              ? state.cartSelections.product
              : {}),
            toolsProductItems: action.data,
          },
        },
      };

    case ActionType.SAVE_CART_SELECTIONS_OPTIONAL_TOOLS_PRODUCT_ITEMS:
      return {
        ...state,
        cartSelections: {
          ...state.cartSelections,
          optional: {
            ...(state.cartSelections?.optional
              ? state.cartSelections.optional
              : {}),
            toolsProductItems: action.data,
          },
        },
      };

    case ActionType.SAVE_CART_SELECTIONS_OPTIONAL_TILTROTATOR:
      return {
        ...state,
        cartSelections: {
          ...state.cartSelections,
          optional: {
            ...(state.cartSelections?.optional
              ? state.cartSelections.optional
              : {}),
            tiltrotator: action.data,
          },
        },
      };

    case ActionType.SAVE_CART_SELECTIONS_OPTIONAL_MACHINE_FIXING:
      return {
        ...state,
        cartSelections: {
          ...state.cartSelections,
          optional: {
            ...(state.cartSelections?.optional
              ? state.cartSelections.optional
              : {}),
            machineFixing: action.data,
          },
        },
      };

    case ActionType.SAVE_CART_SELECTIONS_OPTIONAL_GRAPPLE_MODULE:
      return {
        ...state,
        cartSelections: {
          ...state.cartSelections,
          optional: {
            ...(state.cartSelections?.optional
              ? state.cartSelections.optional
              : {}),
            grappleModule: action.data,
          },
        },
      };

    case ActionType.SAVE_CART_SELECTIONS_OPTIONAL_NO_GRAPPLE_MODULE_SELECTED:
      return {
        ...state,
        cartSelections: {
          ...state.cartSelections,
          optional: {
            ...(state.cartSelections?.optional
              ? state.cartSelections.optional
              : {}),
            isNoneGrappleModuleSelected: action.data,
          },
        },
      };

    case ActionType.SAVE_CART_OPTIONAL_TOOLS_PRODUCT_ITEMS:
      return {
        ...state,
        cart: {
          ...state.cart,
          optional: {
            ...(state.cartSelections?.optional
              ? state.cartSelections.optional
              : {}),
            toolsProductItems: action.data,
          },
        },
      };

    case ActionType.SAVE_EPISERVER_URLS:
      return {
        ...state,
        epiLinks: {
          ...state.epiLinks,
          [action.data.type]: action.data.result,
        },
      };

    case ActionType.SAVE_CONTACT_US_FORM:
      return {
        ...state,
        contactUsFormValues: { ...action.data },
      };

    case ActionType.SAVE_IS_LOADED_FROM_SUMMARY:
      return {
        ...state,
        isLoadedFromSummary: action.data,
      };

    case ActionType.MOVE_CART_PRODUCT_SELECTIONS_TO_CART:
      return {
        ...state,
        cart: { ...state.cart, product: { ...state.cartSelections.product } },
        cartSelections: { ...state.cartSelections, product: action.data },
      };

    case ActionType.MOVE_CART_OPTIONAL_SELECTIONS_TO_CART:
      return {
        ...state,
        cart: { ...state.cart, optional: { ...state.cartSelections.optional } },
        cartSelections: { ...state.cartSelections, optional: action.data },
      };

    case ActionType.COPY_CART_PRODUCT_TO_CART_PRODUCT_SELECTIONS:
      return {
        ...state,
        cartSelections: {
          ...state.cartSelections,
          product: { ...state.cart.product },
        },
      };

    case ActionType.COPY_CART_OPTIONAL_TO_CART_OPTIONAL_SELECTIONS:
      return {
        ...state,
        cartSelections: {
          ...state.cartSelections,
          optional: { ...state.cart.optional },
        },
      };

    case ActionType.RESTORE_STATE_FROM_SUMMARY:
      return {
        ...action.data,
        products: { ...state.products },
      };

    case ActionType.CLEAR_CART:
      return {
        ...state,
        cart: action.data,
      };

    case ActionType.CLEAR_CART_SELECTIONS:
      return {
        ...state,
        cartSelections: action.data,
      };

    default:
      return state;
  }
};

export { reducers };
